<template>
    <MainContent title="Campaña de abonados">
        <template v-slot:header>
            <h3 class="card-title pb-3">Campaña de abonados</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="!loading">
                <div class="col-12">
                    <FormCampanaAbonados :listaAbonados="listaAbonados" @terminado="guardarAbonado"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormCampanaAbonados from '@/components/backend/campana-abonos/FormCampanaAbonos';

    export default {   
        data() {
            return {
                listaAbonados: null,
                loading: false,
            }
        },
        created() {
            this.getAbonado();
        },
        methods: {
            getAbonado() {
                const data = {
                    lista_id: this.$store.getters.getListaId
                };

                this.$store.dispatch(this.config.getVuexAlias('back.campana-abonos.index'), data).then(res => {
                    this.listaAbonados = res.data.data
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editarAbonado();
                }
            },
            guardarAbonado() {
                this.loading = true;

                const data = {
                    lista_id: this.$store.getters.getListaId,
                    imagen: this.listaAbonados.imagen,
                    texto_abonos: this.listaAbonados.texto_abonos,
                    texto_precios: this.listaAbonados.texto_precios,
                    check_sale: this.listaAbonados.check_sale
                }   

                this.$store.dispatch(this.config.getVuexAlias('back.campana-abonos.guardar'), data).then(res => {
                    this.$toast.success(res.data.message);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            MainContent, FormCampanaAbonados
        }
    }
</script>